export default __webpack_public_path__ + "static/media/nanny2.a8231678.jpeg";